import styled from 'styled-components';

export const TripInfoDetailOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
    `
);